import { gql } from 'graphql.macro';
import { apiClientFieldsFragment } from './query.graphql';

export const createApiClientTemplate = gql`
    mutation createApiClient($input: CreateApiClientInput!) {
        createApiClient(input: $input) {
            apiClient {
                ...apiClientFields
            }
            clientSecret
        }
    }
    ${apiClientFieldsFragment}
`;

export const rotateApiClientSecretTemplate = gql`
    mutation rotateApiClientSecret($id: MongoDbObjectId!) {
        rotateApiClientSecret(id: $id) {
            apiClient {
                ...apiClientFields
            }
            clientSecret
        }
    }
    ${apiClientFieldsFragment}
`;

export const setApiClientDisabledTemplate = gql`
    mutation setApiClientDisabled($id: MongoDbObjectId!, $disabled: Boolean!) {
        setApiClientDisabled(id: $id, disabled: $disabled) {
            ...apiClientFields
        }
    }
    ${apiClientFieldsFragment}
`;

export const updateApiClientTemplate = gql`
    mutation updateApiClient($id: MongoDbObjectId!, $input: UpdateApiClientInput!) {
        updateApiClient(id: $id, input: $input) {
            ...apiClientFields
        }
    }
    ${apiClientFieldsFragment}
`;

export const deleteApiClientTemplate = gql`
    mutation deleteApiClient($id: MongoDbObjectId!) {
        deleteApiClient(id: $id)
    }
`;

export const mintApiDocsAutoLoginTokenTemplate = gql`
    mutation mintApiDocsAutoLoginToken($organizationId: MongoDbObjectId!) {
        mintApiDocsAutoLoginToken(organizationId: $organizationId)
    }
`;
